import {Container} from "react-bootstrap";
import {LastRegisteredMachines} from "../components/pages/machines/LastRegisteredMachines";
import {MachinesSummary} from "../components/pages/machines/MachinesSummary";

export const Machines = () => {

    return (
        <Container fluid>

            <MachinesSummary />
            <LastRegisteredMachines />
        </Container>
    );
};